import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { selectCurrentPath, setCurrentPath } from "../../features/userSlice";
import { useSelector } from "react-redux";
import {
  setSelectedComponents,
  setSelectedFeatures,
  setSelectedSharedUid,
  setSelectedSite,
} from "../../features/templateSlice";
import {
  setSelectedFeatures as setSelectedFeaturesTheme,
  setSelectedGroups,
  setSelectedSite as setSelectedSiteTheme,
  setSelectedSharedUid as setSelectedSharedUidTheme,
} from "../../features/themeSlice";
import store from "../../store";
import { setSelectedMetaSearchSite } from "../../features/metaEntitiesSlice";
import {
  setSelectedAsset,
  setSelectedDate,
  setSelectedSource,
} from "../../features/manualExpenseSlice";
import {
  setSelectedAssignee,
  setSelectedCategory,
  setSelectedDueDate,
  setSelectedPriority,
  setSelectedSearchSite,
  setSelectedStatus,
  setSelectedTarget,
} from "../../features/actionItemsSlice";
import {
  setSelectedFilterPopups,
  setSelectedFilterTheme,
  setSelectedSharedUid as setSelectedSharedUidPageGroup,
  setSelectedSite as setSelectedSitePageGroup,
} from "../../features/pageGroupSlice";
import {
  setSelectedAssets,
  setSelectedLabels,
  setSelectedNoteDate,
  setSelectedNotetitle,
  setSelectedStakeholders,
} from "../../features/activityNoteSlice";
import {
  setSelectedAccount,
  setSelectedCompany,
  setSelectedDataCollectionBrands,
  setSelectedRawTableId,
  setSelectedWebsites,
  setSelectedStatus as setSelectedStatusBrands,
  setSelectedInterface,
  setSelectedBrands,
} from "../../features/dataCollectionBrandsSlice";
import {
  setSelectedDatabase,
  setSelectedId,
  setSelectedQueryName,
} from "../../features/dataStoreReqSlice";
import { setSelectedType } from "../../features/websiteActionSlice";
import {
  setSelectedMultiplePackages,
  setSelectedPackage,
  setSelectedPackageBrand,
  setSelectedPackageDateRange,
  setSelectedPackageInterface,
  setSelectedPackageStatus,
  setSelectedProcessName,
} from "../../features/monitoringPackagesSlice";
import {
  setSelectedLogsBrand,
  setSelectedLogsInterface,
  setSelectedLogsPackage,
  setSelectedLogsProcessName,
  setSelectedLogsStatus,
  setSelectedPackageAutoComplete,
  setSelectedPodName,
  setSelectedProcessLogsDateRange,
  setSelectedWorkFlow,
} from "../../features/monitoringProcessLogsSlice";
import {
  setFilteringDefJSONOutput,
  setSelectedDestinationTable,
  setSelectedDestinationTableCreateScreen,
  setSelectedInterfaceCreateScreen,
  setSelectedInterface as setSelectedInterfaceUniqueDef,
  setSelectedUniqueDefDestinationTable,
  setSelectedUniqueDefID,
  setSelectedUniqueDefInterfaceName,
  setUniqueDefinitionData,
} from "../../features/uniqueDefSlice";
import {
  setAssetManagementData,
  setSelectedPage,
  setSitePages,
  setSelectedSite as setSelectedSiteAssetManagement,
  setSelectedOptionGroup,
  setSelectedOptionStatus,
  setPageDetails,
} from "../../features/assetManagementSlice";
import {
  setDataSet,
  setFetchBy,
  setOrganizationDimensions,
  setOrganizationOptions,
  setSelectedEndDate,
  setSelectedStartDate,
  setTrendsDashboardExecuteQueriesData,
  setSelectedSharedUid as setSelectedSharedUidTrends,
  clearTrendsFilters,
  setCountryDataTrendsBreakdown,
  setTrafficSourceDataTrendsBreakdown,
  setCampaignDataTrendsBreakdown,
  setAdGroupDataTrendsBreakdown,
  setKeywordMatchTypeDataTrendsBreakdown,
  setBrandsDataTrendsBreakdown,
  setInCampaignBD,
  setSelectedKeyword,
  setSelectedMatchTypeFilterBD,
  setSelectedCampaignFilterBD,
  setSelectedAdGroupFilterBD,
  setSelectedTrafficSourceFilterBD,
  setSelectedSearchBrand,
} from "../../features/trendsSlice";
import dayjs from "dayjs";
import {
  setAllAdvertisingAccounts,
  setAllCampaigns,
  setCostWeightchartData,
  setLpLoader,
  setPerformanceByKeywords,
  setRelevantAccountsBasedOnSite,
  setSelectedLPAccount,
  setSelectedLPCampaign,
  setSelectedLPDateRange,
  setSelectedLPSharedUid,
  setSiteDimensions,
} from "../../features/landingPageExperienceSlice";

import {
  setSelectedSharedUid as setSelectedSharedUidPageSpeedPerformance,
  setDevice as setDevicePageSpeedPerformance,
  setSelectedInterval,
  setSelectedPriode,
} from "../../features/pageSpeedPerformanceSlice";
import { resetDealsPromotions } from "../../features/dealsPromotionsSlice";
import { resetMobileState } from "../../features/bizDevelopmentDashboardMobileSlice";
import { resetBusinessLeaderDashboard } from "../../features/businessLeaderDashboardSlice";
import { resetEngagementIncentives } from "../../features/engagementIncentivesSlice";
import {
  clearOverviewConversionsFilterOptions,
  clearOverviewConversionsFilters,
  setIsOverviewAccountSummaryLoading,
  setIsOverviewConversionsFilterLoading,
  setIsOverviewConversionsLoading,
  setIsOverviewConversionsNotesLoading,
  setOverviewAccountSummaryActiveRequestKey,
  setOverviewAccountSummaryLoadedRequestKey,
  setOverviewAccountSummaryOutput,
  setOverviewConversionsBaseFilterOptionsLoaded,
  setOverviewConversionsDataSet,
  setOverviewConversionsLoadedRequestKey,
  setOverviewConversionsNotes,
  setOverviewConversionsNotesLoadedRequestKey,
  setOverviewConversionsOutput,
} from "../../features/bizDevelopmentDashboardSlice";
import {
  setSelectedActive,
  setSelectedCalculationName,
  setSelectedDocumented,
  setSelectedMissedRun,
} from "../../features/unifierCalculationTypesSlice";

const BIZ_DEV_MOBILE_PARAMS = [
  "timeframePerformance",
  "additionalTimeframePerformance",
  "sortKeyPerformance",
  "sortDirPerformance",
  "sites",
  "timeframeOverviewAccountSummary",
];

const TRENDS_MOBILE_PARAMS = [
  "startDateTM",
  "endDateTM",
  "dateType",
  "view-Trends",
  "filterTrafficSource",
  "filterCountry",
  "filterCampaignId",
  "filterCampaignName",
  "filterAdGroupId",
  "filterAdGroupName",
  "filterKeywordId",
  "filterKeywordName",
  "timeUnitCi",
  "timeUnitCo",
  "timeUnitCoi",
  "timeUnitCpc",
  "timeUnitEpc",
  "timeUnitFr",
  "timeUnitImp",
  "timeUnitCr",
  "timeUnitAcpa",
  "timeUnitCpa",
  "timeUnitCpapv",
  "timeUnitCac",
  "timeUnitFtd",
  "timeUnitGftdqftd",
  "timeUnitPftd",
  "timeUnitNrpf",
  "timeUnitPv",
  "timeUnitP",
  "timeUnitS",
  "timeUnitTi",
  "timeUnitArspd",
  "timeUnitRs",
  "timeUnitRspv",
  "timeUnitCacMobile",
  "timeUnitCiMobile",
  "timeUnitCoMobile",
  "timeUnitCoiMobile",
  "timeUnitCpcMobile",
  "timeUnitEpcMobile",
  "timeUnitFrMobile",
  "timeUnitImpsMobile",
  "timeUnitAcpaiMobile",
  "timeUnitCpaiMobile",
  "timeUnitCpapvMobile",
  "timeUnitCrMobile",
  "timeUnitPftdMobile",
  "timeUnitGftdqftdMobile",
  "timeUnitPMobile",
  "timeUnitSMobile",
  "timeUnitTiMobile",
  "timeUnitNrpfMobile",
  "timeUnitPvMobile",
  "timeUnitArspdMobile",
  "timeUnitRsMobile",
  "timeUnitRspvMobile",
];

const BIZ_LEADER_PARAMS = [
  "view",
  "period",
  "startDateForBudget",
  "endDateForBudget",
  "modeForBudget",
  "searchBrandForBudget",
  "dateForKeywords",
  "searchKeywordForKeywords",
  "dateForBrands",
  "searchBrandForBrands",
  "periodFromWebsite",
  "tabOfWebsite",
  "selectedSharedUids",
  "selectedDimension",
  "selectedPeriod",
  "selectedType",
  "selectedInterval",
];

const INCENTIVES_PARAMS = [
  "selectedSites",
  "dataSetType",
  "periodTab1",
  "periodTab2",
  "periodTab3",
  "startDateTab1",
  "endDateTab1",
  "startDateTab2",
  "endDateTab2",
  "startDateTab3",
  "endDateTab3",
  "brandNameTab2",
  "brandNameTab3",
  "pagePerformanceByDayBrand",
  "pageBudgetControl",
  "pageClickData",
];

// Maps, Calculation Types and Unique Definitions are tabs of the Unifier
// module rather than routes of their own, so which one is on screen is read
// from ?tab= instead of the pathname
const UNIFIER_PATH = "data_collection/unifier";
const UNIFIER_CALCULATION_TYPES_TAB = "1";
const UNIFIER_UNIQUE_DEFINITIONS_TAB = "2";
// sub-pages the Unique Definitions tab sends the user to and gets them back
// from - its filters survive that round trip, but not a tab or module change
const UNIFIER_DEFINITION_SUB_PAGES = [
  "create_new_definition",
  "edit_definition",
  "duplicate_definition",
];

const RouteTracker = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [, setSearchParams] = useSearchParams();
  const currentPath = useSelector(selectCurrentPath).split("/");

  const isUnifierPath = location.pathname.includes(UNIFIER_PATH);
  const unifierTab = new URLSearchParams(location.search).get("tab");
  const isCalculationTypesTab =
    isUnifierPath && unifierTab === UNIFIER_CALCULATION_TYPES_TAB;
  const isUniqueDefinitionsArea =
    (isUnifierPath && unifierTab === UNIFIER_UNIQUE_DEFINITIONS_TAB) ||
    UNIFIER_DEFINITION_SUB_PAGES.some((subPage) =>
      location.pathname.includes(subPage),
    );

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("templates")) {
      store.dispatch(setSelectedFeatures(null));
      store.dispatch(setSelectedComponents(null));
      store.dispatch(setSelectedSite(null)); // Reset selectedSite when leaving the templates page()
      store.dispatch(setSelectedSharedUid(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("meta_entities")) {
      store.dispatch(setSelectedMetaSearchSite(null)); // Reset selectedSite when leaving the templates page()
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("page_builder")) {
      dispatch(setSitePages([]));
      dispatch(setSelectedOptionGroup([]));
      dispatch(setSelectedOptionStatus([]));
      dispatch(setSelectedDate([]));
      dispatch(setPageDetails([]));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    if (!currentPath.includes("manual_expenses")) {
      store.dispatch(setSelectedAsset(null));
      store.dispatch(setSelectedSource(null));
      store.dispatch(setSelectedDate(null)); // Reset selectedSite when leaving the templates page()
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("theme")) {
      dispatch(setSelectedFeaturesTheme(null));
      dispatch(setSelectedGroups(null));
      dispatch(setSelectedSiteTheme(null)); // Reset selectedSite when leaving the templates page()
      dispatch(setSelectedSharedUidTheme(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("action_items")) {
      dispatch(setSelectedCategory(null));
      dispatch(setSelectedStatus(null));
      dispatch(setSelectedDueDate(null));
      dispatch(setSelectedPriority(null));
      dispatch(setSelectedAssignee(null));
      dispatch(setSelectedTarget(null));
      dispatch(setSelectedSearchSite(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("page_groups")) {
      dispatch(setSelectedFilterTheme(null));
      dispatch(setSelectedFilterPopups(null));
      dispatch(setSelectedSharedUidPageGroup(null));
      dispatch(setSelectedSitePageGroup(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("activity_notes")) {
      dispatch(setSelectedNotetitle(null));
      dispatch(setSelectedAssets(null));
      dispatch(setSelectedStakeholders(null));
      dispatch(setSelectedNoteDate(null));
      dispatch(setSelectedLabels(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname));
    if (!location.pathname.includes("brand_data")) {
      dispatch(setSelectedDataCollectionBrands(null));
      dispatch(setSelectedAccount(null));
      dispatch(setSelectedCompany(null));
      dispatch(setSelectedWebsites(null));
      dispatch(setSelectedStatusBrands(null));
      dispatch(setSelectedRawTableId(null));
      dispatch(setSelectedInterface(null));
      dispatch(setSelectedBrands(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("queries")) {
      dispatch(setSelectedQueryName(null));
      dispatch(setSelectedType(null));
      dispatch(setSelectedDatabase(null));
      dispatch(setSelectedId(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("data_workflows")) {
      dispatch(setSelectedPackage(null));
      dispatch(setSelectedMultiplePackages(null));
      dispatch(setSelectedProcessName(null));
      dispatch(setSelectedPackageStatus(null));
      dispatch(setSelectedPackageBrand(null));
      dispatch(setSelectedPackageDateRange(null));
      dispatch(setSelectedPackageInterface(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("data_logs")) {
      dispatch(setSelectedWorkFlow(null));
      dispatch(setSelectedLogsPackage(null));
      dispatch(setSelectedLogsProcessName(null));
      dispatch(setSelectedLogsStatus(null));
      dispatch(setSelectedLogsBrand(null));
      dispatch(setSelectedProcessLogsDateRange(null));
      dispatch(setSelectedLogsInterface(null));
      dispatch(setSelectedPackageAutoComplete(null));
      dispatch(setSelectedPodName(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!isUniqueDefinitionsArea) {
      dispatch(setSelectedInterfaceUniqueDef(null));
      dispatch(setSelectedDestinationTable(null));
      dispatch(setSelectedUniqueDefID([]));
      dispatch(setSelectedUniqueDefInterfaceName([]));
      dispatch(setSelectedUniqueDefDestinationTable([]));
      dispatch(setUniqueDefinitionData([]));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!isCalculationTypesTab) {
      dispatch(setSelectedCalculationName(null));
      dispatch(setSelectedMissedRun([]));
      dispatch(setSelectedDocumented([]));
      dispatch(setSelectedActive([]));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("create_new_definition")) {
      dispatch(setSelectedInterfaceCreateScreen(null));
      dispatch(setSelectedDestinationTableCreateScreen(null));
      dispatch(setFilteringDefJSONOutput(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("page_management")) {
      store.dispatch(setAssetManagementData(null));
      store.dispatch(setSelectedSiteAssetManagement(null));
      store.dispatch(setSelectedPage(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!location.pathname.includes("trends")) {
      store.dispatch(setFetchBy("site"));
      store.dispatch(setDataSet("click"));
      store.dispatch(setTrendsDashboardExecuteQueriesData([]));
      store.dispatch(setSelectedStartDate(dayjs().startOf("month")));
      store.dispatch(setSelectedEndDate(dayjs().endOf("month")));
      store.dispatch(setOrganizationOptions([]));
      store.dispatch(setOrganizationDimensions([]));
      store.dispatch(setSelectedSharedUidTrends([]));
      store.dispatch(clearTrendsFilters());
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("breakdown")) {
      store.dispatch(setCountryDataTrendsBreakdown([]));
      store.dispatch(setTrafficSourceDataTrendsBreakdown([]));
      store.dispatch(setCampaignDataTrendsBreakdown([]));
      store.dispatch(setAdGroupDataTrendsBreakdown([]));
      store.dispatch(setKeywordMatchTypeDataTrendsBreakdown([]));
      store.dispatch(setBrandsDataTrendsBreakdown([]));
      store.dispatch(setInCampaignBD(null));
      store.dispatch(setSelectedKeyword(null));
      store.dispatch(setSelectedMatchTypeFilterBD(null));
      store.dispatch(setSelectedCampaignFilterBD(null));
      store.dispatch(setSelectedAdGroupFilterBD(null));
      store.dispatch(setSelectedTrafficSourceFilterBD(null));
      store.dispatch(setSelectedSearchBrand(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("landing_page_experience")) {
      dispatch(setSelectedLPSharedUid(""));
      dispatch(setSelectedLPAccount(""));
      dispatch(setSelectedLPDateRange([]));
      dispatch(setSelectedLPCampaign(""));
      dispatch(setAllAdvertisingAccounts([]));
      dispatch(setRelevantAccountsBasedOnSite([]));
      dispatch(setAllCampaigns([]));
      dispatch(setCostWeightchartData([]));
      dispatch(setPerformanceByKeywords([]));
      dispatch(setLpLoader(false));
      dispatch(setSiteDimensions([]));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("page_speed_performance")) {
      dispatch(setSelectedSharedUidPageSpeedPerformance(null));
      dispatch(setDevicePageSpeedPerformance({ label: "Mobile" }));
      dispatch(setSelectedInterval({ label: "Month", value: "month" }));
      // dispatch(
      //   setQuarter({
      //     label: null,
      //     startMonth: null,
      //     endMonth: null,
      //   })
      // );
      dispatch(setSelectedPriode(dayjs()));
    }
    // eslint-disable-next-line
  }, [location]);

  useEffect(() => {
    if (!location.pathname.includes("deals_and_promotions")) {
      store.dispatch(resetDealsPromotions());
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    //Overview Dashboard
    if (!location.pathname.includes("biz_development/dashboard")) {
      dispatch(setIsOverviewAccountSummaryLoading(false));
      dispatch(setOverviewAccountSummaryOutput([]));
      dispatch(setOverviewAccountSummaryLoadedRequestKey(null));
      dispatch(setOverviewAccountSummaryActiveRequestKey(null));
      dispatch(setIsOverviewConversionsLoading(false));
      dispatch(setOverviewConversionsOutput([]));
      dispatch(setOverviewConversionsLoadedRequestKey(null));
      dispatch(setOverviewConversionsDataSet("action"));
      dispatch(clearOverviewConversionsFilters());
      dispatch(clearOverviewConversionsFilterOptions());
      dispatch(setIsOverviewConversionsFilterLoading(false));
      dispatch(setIsOverviewConversionsNotesLoading(false));
      dispatch(setOverviewConversionsNotes([]));
      dispatch(setOverviewConversionsNotesLoadedRequestKey(null));
      dispatch(setOverviewConversionsBaseFilterOptionsLoaded(false));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname));
    if (!location.pathname.includes("biz_development/dashboard")) {
      dispatch(resetMobileState());
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    if (!location.pathname.includes("business_leader/dashboard")) {
      dispatch(resetBusinessLeaderDashboard());
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    if (
      !location.pathname.includes("business_development/incentives_traffic")
    ) {
      dispatch(resetEngagementIncentives());
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  // Single consolidated URL param cleanup — one setSearchParams call per navigation
  // so deletions from different modules don't race and overwrite each other.
  useEffect(() => {
    setSearchParams(
      (params) => {
        if (!location.pathname.includes("biz_development/dashboard")) {
          BIZ_DEV_MOBILE_PARAMS.forEach((key) => params.delete(key));
        }
        if (!location.pathname.includes("business_leader/dashboard")) {
          BIZ_LEADER_PARAMS.forEach((key) => params.delete(key));
        }
        if (
          !location.pathname.includes("business_development/incentives_traffic")
        ) {
          INCENTIVES_PARAMS.forEach((key) => params.delete(key));
        }
        if (!location.pathname.includes("trends")) {
          TRENDS_MOBILE_PARAMS.forEach((key) => params.delete(key));
        }
        return params;
      },
      { replace: true },
    );
    // eslint-disable-next-line
  }, [location.pathname]);

  return null; // No UI needed, just tracking route changes
};

export default RouteTracker;
